import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { City } from '../common/city';
import { Country } from '../common/country';
import { Address } from './address';
import { Contact } from './contact';

@Injectable()
export class ContactInfoService {
  getCountryNameByCityId(cityId: string) {
    const url = this.urlSignature.cityByIdUrl + cityId;
    return this.httpClient.get(url).pipe(map((response) => response as City));
  }
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getContactInfo(personId: String): Observable<Contact> {
    const url = this.urlSignature.contactUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Contact));
  }

  getAddressInfo(addressId: String): Observable<Address> {
    const url = this.urlSignature.addressUrl + addressId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Address));
  }

  getContactById(contactId: String): Observable<Contact> {
    const url = this.urlSignature.contactByIdUrl + contactId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Contact));
  }
}
